module.exports = __webpack_public_path__ + "img/trx.7bd1f669.svg";